import type { FaireProductEntity } from "../../entity_types/product";

export const p_y36uve6kv5: FaireProductEntity = {
  token: "p_y36uve6kv5",
  type: "product",
  name: "Gummy Bears",
  brandToken: "b_dkshdskwmr",
  brandName: "King Henry's",
  imageUrl: "https://cdn.faire.com/fastly/bf13d11a104cc7704a587714376dace3092671448405943ba37d240456f18129.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.52,
  description: "Experience the delightful taste of King Henry's Gummy Bears. As a part of our extensive range of confections, these gummies are a testament to our 30-year legacy of providing high-quality snacks. As a woman-owned national snack company, we prioritize cost, quality, and variety. Our gummy bears offer an unbeatable combination of flavor and value, making them an ideal choice for those who love sweet treats. Enjoy the premium quality of King Henry's products with every bite.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:03.784Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
